<template>
  <div class="container has-text-left">
    <template v-if="formVisible">
      <b-field label="Region ID">
        <b-input v-model="regionId" placeholder="Region ID"/>
      </b-field>
      <b-field label="Object Ref">
        <b-input v-model="objectRef" placeholder="Fill object name"/>
      </b-field>
      <b-button type="is-success" class="is-small" @click="handleAdd">Add</b-button>
    </template>
    <template v-if="!formVisible">
      <div class="container has-text-left">
        <b-button type="is-success" class="is-small" @click="toggleForm">Add device</b-button>
      </div>
    </template>
    <hr class="divider"/>
    <template v-if="tableData.length > 0">
      <b-table
          :narrowed="true"
          :striped="true"
          :data="tableData"
      >
        <template slot-scope="props">
          <b-table-column label="Region ID" field="regionId">{{props.row.regionId}}</b-table-column>
          <b-table-column label="Object" field="objectRef">{{props.row.objectRef}}</b-table-column>
          <b-table-column numeric>
            <b-button type="is-danger" class="is-small" @click="handleRemove(props.row)">Remove</b-button>
          </b-table-column>
        </template>
      </b-table>
    </template>
    <template v-else>
      <div class="no_device_set">No presence detector devices configured.</div>
    </template>
  </div>
</template>

<script>
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BInput,
      BField,
      BTableColumn,
      BTable
    },
    name: "user-presence-detector-devices",
    props: ['userId', 'list', 'update'],
    data() {
      return {
        formVisible: false,
        regionId: 0,
        objectRef: '',
        collected: []
      };
    },
    computed: {
      tableData() {
        const ret = [];

        this.collected.forEach(item => {
          const { objectRef, regionId } = item;
          ret.push({
            regionId,
            objectRef
          });
        });

        return ret;
      }
    },
    methods: {
      toggleForm() {
        this.formVisible = !this.formVisible;
      },
      clearForm() {
        this.regionId = 0;
        this.objectRef = '';
      },
      handleAdd() {
        this.collected.push({
          regionId: this.regionId,
          objectRef: this.objectRef
        });
        this.update({
          userId: this.userId,
          list: this.collected
        });
        this.toggleForm();
        this.clearForm();
      },
      handleRemove({ regionId, objectRef }) {
        if (confirm("Are you sure ?")) {
          this.collected = this.collected.filter(item => {
            const { regionId: rid, objectRef: obj } = item;
            return parseInt(rid, 10) !== parseInt(regionId, 10) && obj !== objectRef;
          });
          this.update({
            userId: this.userId,
            list: this.collected
          });
        }
      }
    },
    mounted() {
      this.formVisible = false;
      this.clearForm();
      this.collected = this.list.map(item => {
        const { region_id, object_ref } = item;
        return {
          regionId: region_id,
          objectRef: object_ref
        };
      });
    }
  }
</script>

<style scoped>
  .no_device_set {
    font-size: 1rem;
    font-style: italic;
    color: #ffa117;
  }

  .divider {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
</style>